interface InputState {
  value: string;
  selection: { start: number; end: number } | null;
}

interface BeforeMaskedStateChangeStates {
  previousState?: InputState;
  currentState?: InputState;
  nextState: InputState;
}

export const beforeTimeMaskedStateChange = ({
  nextState
}: BeforeMaskedStateChangeStates): InputState => {
  const { value } = nextState;
  let newValue = value;

  // Разбиваем на компоненты
  const parts = value.split(':');

  if (parts[0]) {
    // Часы: ограничиваем 00-23
    const hours = parseInt(parts[0], 10);
    if (parts[0].length === 1 && hours > 2) {
      parts[0] = '2';
    } else if (parts[0].length === 2) {
      if (hours > 23) {
        parts[0] = '23';
      }
    }
  }

  if (parts[1]) {
    // Минуты: ограничиваем 00-59
    const minutes = parseInt(parts[1], 10);
    if (parts[1].length === 1 && minutes > 5) {
      parts[1] = '5';
    } else if (parts[1].length === 2) {
      if (minutes > 59) {
        parts[1] = '59';
      }
    }
  }

  newValue = parts.join(':');

  return {
    ...nextState,
    value: newValue
  };
};
